import { DadosLoteamentoComercial, ValidacaoLoteamentoComercial } from 'models/Viabilidade/DadosLoteamentoComercial'
import * as S from './index.style'
import Grid from 'components/Grid'
import { InputBaseComponentProps, TextField } from '@material-ui/core'
import { ElementType, useState } from 'react'
import { MascaraDecimal } from 'components/Mascara/Decimal'
import { MascaraInteiro } from 'components/Mascara/Inteiro'
import { secaoOpcional } from 'helpers/Constantes/Mensagens'

const LoteamentoComercial: React.FC<{
  dadosLoteamentoComercial: DadosLoteamentoComercial
  dadosLoteamentoComercialHandler: (novoValor: DadosLoteamentoComercial) => void
}> = ({ dadosLoteamentoComercial, dadosLoteamentoComercialHandler }) => {
  const [mensagensErro, setMensagensErro] = useState(new ValidacaoLoteamentoComercial())
  const [valores, setValores] = useState(dadosLoteamentoComercial)

  const replaceState = (event: React.ChangeEvent<HTMLInputElement>): Record<string, unknown> => {
    const state = { ...valores } as Record<string, unknown>
    state[event.target.name] = event.target.value
    return state
  }

  const camposHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = replaceState(event) as DadosLoteamentoComercial
    setValores(state)
    dadosLoteamentoComercialHandler(state)
  }

  const validarCamposPreenchidos = () => {
    const validador = mensagensErro.verificarCamposPreenchidos(valores)
    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarCard = (validador: ValidacaoLoteamentoComercial) => {
    const state = { ...valores } as DadosLoteamentoComercial

    state.valido = validador.validarTodosCampos()
    setValores(state)
    dadosLoteamentoComercialHandler(state)
  }

  return (
    <S.Wrapper data-cy="loteamentoComercial">
      <S.NomeSecao>
        Loteamento Comercial <S.SecaoOpcional>{secaoOpcional}</S.SecaoOpcional>
      </S.NomeSecao>
      <Grid orientacao="column" gridTemplateColumns="repeat(4, 184px)" gridTemplateRow="1fr" gridGap="48px" margin="0">
        <div>
          <S.Label>Quantidade de Unidades</S.Label>
          <TextField
            placeholder="00"
            name="quantidadeUnidades"
            data-cy="campoloteamentoComercialQuantidadeUnidades"
            value={valores.quantidadeUnidades}
            type="text"
            onChange={camposHandler}
            onBlur={validarCamposPreenchidos}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraInteiro as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.quantidadeUnidades != ''}
            helperText={mensagensErro.quantidadeUnidades}
          />
        </div>
        <div>
          <S.Label>Quantidade de Permutas</S.Label>
          <TextField
            placeholder="00"
            name="quantidadePermutas"
            data-cy="campoloteamentoComercialQuantidadePermutas"
            value={valores.quantidadePermutas}
            onChange={camposHandler}
            onBlur={validarCamposPreenchidos}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraInteiro as unknown as ElementType<InputBaseComponentProps>
            }}
          />
        </div>
        <div>
          <S.Label>Área Lote (m²)</S.Label>
          <TextField
            placeholder="00,00"
            name="areaLote"
            data-cy="campoloteamentoComercialAreaLote"
            value={valores.areaLote}
            onChange={camposHandler}
            onBlur={validarCamposPreenchidos}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.areaLote != ''}
            helperText={mensagensErro.areaLote}
          />
        </div>
        <div>
          <S.Label>Preço Tabela (R$/Unid)</S.Label>
          <TextField
            placeholder="000.000,00"
            name="precoTabela"
            data-cy="campoloteamentoComercialPrecoTabela"
            value={valores.precoTabela}
            onChange={camposHandler}
            onBlur={validarCamposPreenchidos}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.precoTabela != ''}
            helperText={mensagensErro.precoTabela}
          />
        </div>
      </Grid>
    </S.Wrapper>
  )
}

export default LoteamentoComercial
